// /parents DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { OverflowTooltip } from "components/list";
import { IParent } from "../interfaces";

// 수정일 문자열 포맷 (기존 로직 유지)
const formatUpdatedDate = (value: unknown): string => {
  const date = new Date(value as string);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const amPm = hours < 12 ? "오전" : "오후";
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${amPm} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const parentsColumns: GridColDef<IParent>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  { field: "loginId", headerName: "로그인 ID", type: "string", width: 120, minWidth: 100 },
  { field: "name", headerName: "이름", width: 120, minWidth: 100 },
  { field: "nickName", headerName: "닉네임", width: 150, minWidth: 120 },
  { field: "address", headerName: "주소", width: 302, minWidth: 250 },
  {
    field: "location.sido",
    headerName: "시도",
    width: 110,
    minWidth: 90,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.row.location?.sido} />
    ),
  },
  {
    field: "location.sigungu",
    headerName: "시군구",
    width: 120,
    minWidth: 100,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.row.location?.sigungu} />
    ),
  },
  {
    field: "phoneNumber",
    headerName: "전화번호",
    width: 140,
    minWidth: 120,
    renderCell: (params: GridRenderCellParams) => {
      const formattedPhoneNumber =
        params.value && params.value.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      return <OverflowTooltip value={formattedPhoneNumber} />;
    },
  },
  {
    field: "updatedDate",
    headerName: "수정일",
    width: 200,
    minWidth: 150,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={formatUpdatedDate(params.value)} />
    ),
  },
];
